import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ListIcon = svgProps => /*#__PURE__*/_jsxs("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 32 32",
  fill: "currentColor"
}, svgProps, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M28.69 11c.906-.916 1.481-2.162 1.53-3.541V7.45c-.017-1.981-1.627-3.579-3.61-3.579-1.71 0-3.142 1.189-3.515 2.785l-.005.024c1.834 1.061 3.052 3.006 3.07 5.237V22.12h4.06c1.105 0 2-.895 2-2V15v-.028c0-2.044-1.532-3.729-3.511-3.97L28.69 11zM1.78 22.14h4.07v-10.2c.018-2.234 1.236-4.179 3.041-5.224L8.92 6.7C8.542 5.079 7.11 3.891 5.4 3.891c-1.983 0-3.593 1.599-3.61 3.578v.002c.052 1.38.622 2.617 1.521 3.531l-.001-.001c-2.012.229-3.56 1.922-3.56 3.976v.026-.001 5.08l-.001.06c0 1.105.895 2 2 2h.033-.002z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.88 12v12.17c0 1.105.895 2 2 2h12.21c1.105 0 2-.895 2-2V12c0-2.242-1.818-4.06-4.06-4.06h-1.76c.31-.295.583-.623.817-.979l.013-.021c.189-.286.367-.614.514-.959l.016-.041c.257-.589.413-1.274.43-1.994V3.94c0-2.242-1.818-4.06-4.06-4.06s-4.06 1.818-4.06 4.06c.017.726.173 1.411.444 2.035l-.014-.035c.163.386.341.714.545 1.024L12.9 6.94c.247.377.52.705.828.998l.002.002h-1.79c-2.242 0-4.06 1.818-4.06 4.06z"
  })]
}));
export default ListIcon;